"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = propsOrState;
function propsOrState(propName) {
  return this.props[propName] !== undefined ? this.props[propName] : this.state[propName];
}
//# sourceMappingURL=propsOrState.js.map